<template>
  <div class="referrals reset-indent">
    <app-header-container>
      <div class="d-flex align-center">
        {{ $t('views.Referrals.title') }}
      </div>

      <template v-slot:controls v-if="ShowAddUserControl">
        <add-referral @add="onAddReferral" v-model="showAddReferral"></add-referral>
      </template>
      <!--      <template v-slot:interactiveControls><v-button class="ml-auto" color="success" :size="screen.breakPoint.tabPort ? null : 'xs-small'">{{ $t('views.Dashboard.Orders.addOrder') }}</v-button></template>-->
    </app-header-container>

    <div class="referrals-list" v-if="loading">
      <div :class="{ resetIndent }">
        <list-item loading v-for="(item, index) in 10" :key="index.toString() + '-' + item.toString() "></list-item>
      </div>
    </div>

    <div class="referrals-list" v-else>
      <div :class="{ resetIndent }">
        <RecycleScroller
          :items="groupedReferrals"
          :buffer="500"
          key-field="listId"
          page-mode
          v-slot="{ item }"
        >
          <list-item :two-columns="screen.breakPoint.tabPort">
            <template v-slot:groupTitle>
              <div v-if="item.groupDate">
                {{ item.groupDate }}
              </div>
            </template>

            <template v-slot:firstColumn>
              <list-item-title>
                {{ item.externalUserId }}
              </list-item-title>

              <list-item-subtitle>
                {{ item.firstName }} {{ item.lastName }} +{{ item.phone }}
              </list-item-subtitle>
            </template>
            <template v-slot:secondColumn>
              <list-item-subtitle v-if="item.createdByManagerLogin">
                <span class="text-color-space">{{ $t('views.Dashboard.Referrals.manager') }}:</span> {{ item.createdByManagerLogin }}
              </list-item-subtitle>
            </template>
          </list-item>
        </RecycleScroller>

        <div class="mt-1"></div>

        <list-footer
          :loading="fetchingMore || $apollo.queries.referrals.loading"
          :total="!referrals ? 0 : referrals.totalElements"
          short
        ></list-footer>

        <div class="my-2"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeaderContainer from '@/ui/layout/AppHeaderContainer'
import ListFooter from '@/ui/slots/List/ListFooter'

import ListItem from '@/ui/slots/List/ListItem'
import ListItemTitle from '@/ui/slots/List/ListItemTitle'
import ListItemSubtitle from '@/ui/slots/List/ListItemSubtitle'

import AddReferral from '@/components/AddReferral'

import groupByDate from '@/mixins/groupByDate'
import screen from '@/mixins/screen'
import fetchMore from '@/mixins/fetchMore'
import forwardMoreOnMobile from '@/mixins/forwardMoreOnMobile'
import { ShowAddUserControl } from '@/mixins/displayRules'

import { ReferralsGQL } from '@/graphql/queries'
import { StatsUsersGQL } from '@/widgets/RegisteredUsers/queries'

export default {
  name: 'referrals',

  data () {
    return {
      showAddReferral: false,

      queryVars: {
        descending: true,
        registeredMp: null
      },
      paginationVars: {
        page: 0
      }
    }
  },

  components: {
    AppHeaderContainer,
    AddReferral,
    ListFooter,

    ListItem,
    ListItemTitle,
    ListItemSubtitle
  },

  apollo: {
    referrals: {
      query: ReferralsGQL,
      variables () {
        return {
          params: {
            ...this.queryVars,
            ...this.paginationVars
          }
        }
      },
      update: data => data.merchant.referrals
    },

    statsUsers: {
      query: StatsUsersGQL,
      update: data => data.merchant.stats.statsUsers,
      skip () { return !this.hasActiveContracts }
    }
  },

  mixins: [groupByDate, screen, fetchMore, forwardMoreOnMobile, ShowAddUserControl],

  props: {
    resetIndent: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    loading () {
      return this.$apollo.queries.referrals.loading && !this.fetchingMore
    },

    groupedReferrals () {
      const itemSize = this.screen.breakPoint.hugeDesktop ? 72 : 65
      const groupItemSize = this.screen.breakPoint.hugeDesktop ? 123 : 106
      const referrals = this.referrals ? this.referrals.content : []

      return this.groupByDate(referrals, 'createdAt', itemSize, groupItemSize)
    }
  },

  methods: {
    showMore () {
      const params = {
        ...this.paginationVars,
        ...this.queryVars
      }

      this.fetchMore({
        params,
        rootField: 'merchant',
        apolloQueryField: 'referrals',
        currPage: this.referrals.currentPage
      })
    },

    async onAddReferral () {
      await this.$apollo.queries.referrals.refetch()
      await this.$apollo.queries.statsUsers.refetch()
    }
  },

  mounted () {
    document.addEventListener('reachedBottom', this.showMore)
    document.addEventListener('addReferral', this.onAddReferral)
  },

  beforeDestroy () {
    document.removeEventListener('reachedBottom', this.showMore)
    document.removeEventListener('addReferral', this.onAddReferral)
  }
}
</script>
